import { FIXTURES } from "../fixtures";

interface ScenarioSelectorProps {
  scenarioId: string;
  onChange: (id: string) => void;
}

export function ScenarioSelector({ scenarioId, onChange }: ScenarioSelectorProps) {
  const current = FIXTURES.find((fixture) => fixture.id === scenarioId);
  return (
    <div className="field">
      <label htmlFor="scenario-select">Escenario</label>
      <select id="scenario-select" value={scenarioId} onChange={(event) => onChange(event.target.value)}>
        {FIXTURES.map((fixture) => (
          <option key={fixture.id} value={fixture.id}>
            {fixture.label}
          </option>
        ))}
      </select>
      {current ? <p className="field-hint">{current.description}</p> : null}
    </div>
  );
}
